<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6" v-if="propAdd=='tambah'">Tambah Produk</v-card-title>
				<v-card-title class="text-h6" v-else>Edit Produk</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
              <span class="text-h6">Data Produk</span>
							<v-row>
								<v-col cols="12" sm="8" md="8" class="pt-0 text-center">
									<v-row>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-text-field outlined dense @focus="() => konfirmResponse.code=''" :error-messages="konfirmResponse.code"  v-model="paramAdd.code" label="Kode Produk"></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0 text-capitalize">
											<v-text-field outlined dense @focus="() => konfirmResponse.name=''" :error-messages="konfirmResponse.name" v-model="paramAdd.name" label="Nama Produk"></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-currency-field :disabled="isProductSerial" outlined dense @focus="() => konfirmResponse.price=''" :error-messages="konfirmResponse.price" v-model="paramAdd.price" label="Harga Produk Pra MB"></v-currency-field>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-currency-field :disabled="isProductSerial" outlined dense @focus="() => konfirmResponse.price_original=''" :error-messages="konfirmResponse.price_original" v-model="paramAdd.price_original" label="Harga Produk MB"></v-currency-field>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-currency-field :disabled="isProductSerial" outlined dense @focus="() => konfirmResponse.weight=''" :error-messages="konfirmResponse.weight" v-model="paramAdd.weight" label="Berat Produk (gram)"></v-currency-field>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-autocomplete outlined dense  @focus="() => konfirmResponse.category=''" :error-messages="konfirmResponse.category" v-model="paramAdd.category" :items="productCategory" item-text="product_category_name" item-value="product_category_id" label="Kategori" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-combobox outlined dense @focus="() => konfirmResponse.unit=''" :error-messages="konfirmResponse.unit" v-model="paramAdd.unit" :items="productUnit" item-text="type_name" item-value="type_name" label="Unit" no-data-text="Tidak ada data yang sesuai"></v-combobox>
										</v-col>
										<v-col cols="12" sm="6" md="6" class="pt-2 pb-0">
											<v-autocomplete multiple :disabled="isProductSerial" outlined dense  @focus="() => konfirmResponse.allow=''" :error-messages="konfirmResponse.allow" v-model="paramAdd.allow" :items="['pos', 'ecommerce']" label="Tersedia Pada" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
										</v-col>
										<v-col cols="12" sm="12" md="12" class="pt-2 pb-0">
											<v-textarea outlined dense @focus="() => konfirmResponse.description=''" :error-messages="konfirmResponse.description" v-model="paramAdd.description" label="Deskripsi Produk" no-resize height="120"></v-textarea>
										</v-col>
										<v-col cols="4" sm="4" md="4" class="pt-2 pb-0" v-if="false">
											<div class="text-left">Produk Tersedia Untuk: <span v-show="false">{{ paramAdd.allow }}</span></div>
											<v-checkbox
											:disabled="isProductSerial"
											v-model="paramAdd.allow"
											label="Mobile Counter"
											value="ecommerce"
											></v-checkbox>
											<v-checkbox
											:disabled="isProductSerial"
											v-model="paramAdd.allow"
											label="Aplikasi Pos"
											value="pos"
											></v-checkbox>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" sm="4" md="4" class="pt-0 text-center">
									<v-row>
										<v-col cols="12" sm="12" md="12" class="pt-2 pb-0">
											<v-text-field :disabled="isProductSerial" outlined dense @focus="() => konfirmResponse.volume=''" :error-messages="konfirmResponse.volume" v-model="paramAdd.volume" label="Volume Produk (PxLxT)"></v-text-field>
										</v-col>
										<v-col cols="12" sm="12" md="12" class="pt-2 pb-0">
											<v-currency-field :disabled="isProductSerial" outlined dense @focus="() => konfirmResponse.price_employee=''" :error-messages="konfirmResponse.price_employee" v-model="paramAdd.price_employee" label="Harga Produk Karyawan"></v-currency-field>
										</v-col>

										<v-col cols="12" sm="12" md="12" class="pt-2 pb-0">
											<v-avatar tile color="grey" size="140" width="100%">
												<img class="avatar" :src="image" v-if="image">
												<span class="white--text" v-else>Silahkan Pilih Gambar Produk</span>
											</v-avatar>
											<v-file-input v-if="dialog" hide-input ref="inputFile" :rules="rulesImage" @change="handleFileUpload($event)" accept="image/png, image/jpeg, image/jpg" placeholder="Unggah gambar produk" prepend-icon="mdi-camera" label="Gambar Produk" @click:clear="removeImage" clearable hint="Ukuran maksimal file 2Mb" class="icon-upload-image" width="20"></v-file-input>
										</v-col>
									</v-row>
								</v-col>
							</v-row>


              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex justify-space-between">
                    <div class="text-h6 text-left">Data Serial</div>
                    <div class="text-h6 text-right">
                      <v-btn class="mr-2" @click="addSerial()" fab dark x-small depressed color="green darken-1">
												<v-icon dark>mdi-plus</v-icon>
											</v-btn>
                    </div>
                  </div>
                  <v-row v-for="(serial, index) in paramAdd.is_serial" :key="index">
                    <v-col cols="6" sm="6" md="6" class="text-center">
                      <v-autocomplete :disabled="isProductSerial" outlined dense v-model="serial.type_id" :items="serialTypeList" item-text="type_name" item-value="type_id" label="Serial" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" class="text-center">
                      <v-currency-field :disabled="isProductSerial" outlined dense v-model="serial.quantity" label="Jumlah"></v-currency-field>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="text-right">
                      <v-btn class="mr-2" fab dark x-small depressed color="pink" @click="removeSerial(index)">
                        <v-icon dark>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div class="text-center pt-4 text-h6" v-if="!paramAdd.is_serial || paramAdd.is_serial.length == 0">
                    Tidak ada serial
                  </div>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex justify-space-between">
                    <div class="text-h6 text-left">Data Produk Bundle</div>
                    <div class="text-h6 text-right">
                      <v-btn class="mr-2" @click="addBundle()" fab dark x-small depressed color="green darken-1">
												<v-icon dark>mdi-plus</v-icon>
											</v-btn>
                    </div>
                  </div>
                  <v-row v-for="(bundle, index) in paramAdd.include_product_id" :key="index">
                    <v-col cols="6" sm="6" md="6" class="text-center">
                      <v-autocomplete :disabled="isProductSerial" outlined dense v-model="bundle.product_id" :items="productSerial" item-text="product_name" item-value="product_id" label="Produk" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" class="text-center">
                      <v-currency-field :disabled="isProductSerial" outlined dense v-model="bundle.quantity" label="Jumlah"></v-currency-field>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="text-right">
                      <v-btn class="mr-2" fab dark x-small depressed color="pink" @click="removeBundle(index)">
                        <v-icon dark>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div class="text-center pt-4 text-h6" v-if="!paramAdd.include_product_id || paramAdd.include_product_id.length == 0">
                    Tidak ada produk bundle
                  </div>
                </v-col>

              </v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
export default {
	data () {
		return {
			formData: {},
			page: 1,
			limit: "10",
			params: [],
			image: '',
			rulesImage: [
			value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
			],
			paramAdd: {
				code: '',
				name: '',
				price: '',
				price_original: '',
				price_employee: '',
				weight: '',
				unit: '',
				volume: '',
				is_serial: '',
				category: '',
				description: '',
				image: '',
				allow: [],
				include_product_id: '',
			},
		}
	},
	props: {
		value: Boolean,
		propAdd: String,
		edit: String,
		val: Object,
		isProductSerial: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		...mapState('productList', ['konfirmResponse', 'responSukses', 'productUnit', 'productCategory', 'serialType', 'productSerialOption']),

		productSerial() {
			// var product_empty = {
			// 	product_id: '0',
			// 	product_name: 'Tanpa Produk Bundling',
			// 	product_code: 'Tanpa Produk Bundling'
			// }
      var mappedProductSerialOption = this.productSerialOption.map( (val) => {
        return {
          product_id: val.product_id,
          product_name: val.product_name,
          product_code: val.product_code
        }
      })
			// return [product_empty, ...mappedProductSerialOption]
			return mappedProductSerialOption
		},
    serialTypeList() {
      var data = []
      this.serialType.forEach(el => {
        if (el.type_id > 0) {
          el.type_id = String(el.type_id);
          data.push(el)
        }
      })

      return data
    },

		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		}
	},
	methods: {
		...mapMutations('productList', ['konfirmasiSukses']),

		handleFileUpload(event) {
			this.formData.append('image', event);

			if (!event)
				return;

			this.createImage(event);
		},
		createImage(file) {
			var reader = new FileReader();

			reader.onload = (e) => {
				this.image = e.target.result;
			};
			reader.readAsDataURL(file);
		},
		removeImage() {
			this.image = '';
		},
		batal() {
			this.dialog = false
			this.konfirmasiSukses('')
		},
		simpan() {
			this.paramAdd['is_include'] = 'false'
			if (this.isProductSerial) {
				this.paramAdd['is_include'] = 'true'
			}
      // this.paramAdd.include_product_id = (this.val.product_include_product_id)
			// this.paramAdd.is_serial = (this.val.product_is_serial)
			this.$emit('action', this.paramAdd, this.formData)
		},
    addSerial() {
      this.paramAdd.is_serial.push(
        { "type_id": "", "quantity": "", "serial_name": ''}
      )
    },
    removeSerial(index) {
      this.paramAdd.is_serial.splice(index, 1)
    },
    addBundle() {
      this.paramAdd.include_product_id.push(
        { "product_id": "", "product_code": "", "quantity": "" }
      )
    },
    removeBundle(index) {
      this.paramAdd.include_product_id.splice(index, 1)
    }
	},
	watch: {
		dialog(val) {
			if (val) {
				this.formData = new FormData();
				if (this.$refs.inputFile) {
					this.$refs.inputFile.reset()
				}
				this.image = this.val.product_image;
				this.paramAdd.id = this.val.product_id
				this.paramAdd.code = this.val.product_code
				this.paramAdd.name = this.val.product_name
				this.paramAdd.price = this.val.product_price
				this.paramAdd.price_original = this.val.product_price_original
				this.paramAdd.price_employee = this.val.product_price_employee
				this.paramAdd.weight = this.val.product_weight
				this.paramAdd.unit = this.val.product_unit
				this.paramAdd.category = this.val.product_category_id
				this.paramAdd.description = this.val.product_description
				this.paramAdd.volume = this.val.product_volume
				this.paramAdd.allow = this.val.product_allow ? this.val.product_allow.split(','): []
        try {
          this.paramAdd.include_product_id = JSON.parse(this.val.product_include_product_id)
          this.paramAdd.is_serial = JSON.parse(this.val.product_is_serial)
        } catch (err) {
          this.paramAdd.include_product_id = []
          this.paramAdd.is_serial = []
        }
			}
		}
	},
	created() {
	}
}
</script>
